import { CSSProperties, FC } from 'react'
import { DispositivoList } from '../../modules/apps/atendimento/core/_models'
import { DispositivoType } from '../../../_metronic/helpers'

export type IDispositivos = {
  dispositivos: DispositivoList[]
}

type DispositivoConfig = {
  tipo: DispositivoType
  alt: string
  slotWidth?: number
}

const iconSize = 40
const wideIconSize = 56

const dispositivosConfig: DispositivoConfig[] = [
  {
    tipo: DispositivoType.Balanca,
    alt: 'Ícone de balança',
  },
  {
    tipo: DispositivoType.Pressao,
    alt: 'Ícone de aferidor de pressão arterial',
  },
  {
    tipo: DispositivoType.Oximetro,
    alt: 'Ícone de oxímetro',
  },
  {
    tipo: DispositivoType.Termometro,
    alt: 'Ícone de termômetro',
  },
  {
    tipo: DispositivoType.Camera,
    alt: 'Ícone de inspeção',
  },
  {
    tipo: DispositivoType.Otoscopio,
    alt: 'Ícone de otoscópio',
  },
  {
    tipo: DispositivoType.Glicosimetro,
    alt: 'Ícone de glicosímetro',
  },
  {
    tipo: DispositivoType.Estetoscopio,
    alt: 'Ícone de estetoscópio',
  },
  {
    tipo: DispositivoType.Ecg,
    alt: 'Ícone de eletrocardiograma',
  },
  {
    tipo: DispositivoType.Dermatoscopio,
    alt: 'Ícone de dermatoscópio',
    slotWidth: wideIconSize,
  },
  {
    tipo: DispositivoType.Doppler,
    alt: 'Ícone do Doppler',
    slotWidth: wideIconSize,
  },
]

const iconWrapperStyle: CSSProperties = {
  alignItems: 'center',
  display: 'inline-flex',
  flexBasis: iconSize,
  flexGrow: 0,
  flexShrink: 0,
  height: iconSize,
  justifyContent: 'center',
  width: iconSize,
}

const iconStyle: CSSProperties = {
  height: '100%',
  maxHeight: '100%',
  maxWidth: '100%',
  objectFit: 'contain',
  width: '100%',
}

const getIconWrapperStyle = (slotWidth = iconSize): CSSProperties => ({
  ...iconWrapperStyle,
  flexBasis: slotWidth,
  width: slotWidth,
})

export const Dispositivos: FC<IDispositivos> = ({ dispositivos }) => {
  const getIconsPath = (dispositivos: DispositivoList[], tipo: DispositivoType) => {
    const dispositivoEncontrado = dispositivos.find((d) => d.tipo === tipo)

    if (dispositivoEncontrado) {
      return `/media/icons/duotune/sinais/${tipo.toLowerCase()}-on.png`
    } else {
      return `/media/icons/duotune/sinais/${tipo.toLowerCase()}.png`
    }
  }

  return (
    <div className='d-flex flex-wrap gap-1 align-items-center'>
      {dispositivosConfig.map(({ tipo, alt, slotWidth }) => (
        <span key={tipo} style={getIconWrapperStyle(slotWidth)}>
          <img src={getIconsPath(dispositivos, tipo)} alt={alt} style={iconStyle} />
        </span>
      ))}
    </div>
  )
}
